import React from "react";
import { Field, FieldArray } from "formik";
import moment from "moment";
import { Input, Select, DatePicker } from "../../../../../components/formik";

import { optionsType } from "../../../../../prop-types";
import { withError } from "../../../../../components/hocs";
import { Col, Row } from "reactstrap";
// import ButtonSelectPEP from "../../../../../components/formik/upsertWatchlistEntryForm/ButtonSelectPEP";

const ErrorInput = withError(Input);
const DateWithError = withError(DatePicker);
const ErrorSelect = withError(Select);
const NaturalPersonFormFields = ({ nationalities, countries }) => (
  <React.Fragment>
    <Row>
      <Col lg={5} className="pl-0">
        <Field
          placeholder="First name"
          name="name.firstName"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              dateFormat="dd.MM.yyyy"
              label=""
              placeholderText="Date of birth (dd.mm.yyyy)"
              changeOnInput={true}
              name="birthDate"
              maxDate={new Date(moment())}
              minDate={new Date(1900, 0, 1)}
              yearDropdownItemNumber={150}
              component={DateWithError}
            />
          </Col>
          <Col lg={6} className="pr-0">
            <FieldArray name="identifications">
              <Field
                placeholder="Identification number"
                name="identifications[0].number"
                component={ErrorInput}
              />
            </FieldArray>
          </Col>
        </Row>
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5} className="pl-0">
        <Field
          placeholder="Middle name"
          name="name.middleName"
          component={Input}
        />
      </Col>
      <Col lg={7} className="p-0">
        <Row>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="City"
              name="addresses[0].city"
              component={Input}
            />
          </Col>
          <Col lg={6} className="pr-0">
            <Field
              placeholder="Post code"
              name="addresses[0].postalCode"
              component={Input}
            />
          </Col>
        </Row>
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5} className="pl-0">
        <Field
          placeholder="Last name"
          name="name.lastName"
          component={ErrorInput}
        />
      </Col>
      <Col lg={7} className="pr-0">
        <FieldArray name="addresses">
          <Input
            placeholder="Address of residence"
            name="addresses[0].addressOfResidence"
          />
        </FieldArray>
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5} className="pl-0">
        <Field
          placeholder="Country"
          name="addresses[0].countryId"
          className="dropdown-group"
          options={countries}
          component={ErrorSelect}
        />
      </Col>
      <Col lg={7} className="pr-0">
        <Field
          placeholder="Nationality"
          name="nationalityId"
          className="dropdown-group"
          options={nationalities}
          component={ErrorSelect}
        />
      </Col>
    </Row>

    <Row className="mt-4">
      <Col lg={5} className="pl-0">
        <Field
          placeholder="Region"
          name="addresses[0].region"
          component={Input}
        />
      </Col>
      <Col lg={7} className="pr-0">
        {/* Turned off */}
        {/* <Field
          label="Politically exposed person:"
          name="isPolitician"
          component={ButtonSelectPEP}
          options={[
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ]}
        /> */}
      </Col>
    </Row>
  </React.Fragment>
);

NaturalPersonFormFields.propTypes = {
  nationalities: optionsType.isRequired,
};

export default NaturalPersonFormFields;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/upsert-watch-list-entry-form/natural-person-form-fields/NaturalPersonFormFields.jsx